import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AjustedevaloresComponent } from './components/ajustedevalores/ajustedevalores.component';
import { DetalleAjusteDialogComponent } from './components/detalle-ajuste-dialog/detalle-ajuste-dialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { AjustedevaloresRoutingModule } from './ajustedevalores-routing.module';
import { AjusteValoresService } from './services/ajuste-valores.service';
import { ConceptoComisionService } from './services/concepto-comision.service';

@NgModule({
  declarations: [
    AjustedevaloresComponent,
    DetalleAjusteDialogComponent,
    ConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    AjustedevaloresRoutingModule
  ],
  providers: [
    AjusteValoresService,
    ConceptoComisionService
  ]
})
export class AjustedevaloresModule { }
